export default "__VITE_ASSET__CgTmig4A__"